import { fetchSwiper } from '../dynamic-modules';
import { createArrows } from './slider';

function init() {
    const elements = Array.from(document.querySelectorAll('.js-thumbs-slider'));

    elements.forEach(async (container) => {
        const mainSlider = container.querySelector('.js-thumbs-slider--main');
        const secondarySlider = container.querySelector('.js-thumbs-slider--secondary');

        if (!mainSlider || !secondarySlider) {
            throw new Error('[thumbs-slider] Neither main container nor secondary container was found.');
        }

        const slides = Array.from(mainSlider.querySelectorAll('.swiper-slide'));

        if (slides.length > 1) {
            const arrowsContainer = container.querySelector('.swiper-navigation');

            const { default: Swiper, Navigation, Lazy, Thumbs } = await fetchSwiper();
            Swiper.use(Navigation);
            Swiper.use(Lazy);
            Swiper.use(Thumbs);

            if (arrowsContainer) {
                createArrows(arrowsContainer);
            }

            const thumbsSwiper = new Swiper(secondarySlider, {
                slidesPerView: 'auto',
                allowTouchMove: true,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                lazy: {
                    loadPrevNext: true,
                },
            });

            const swiper = new Swiper(mainSlider, {
                speed: 500,
                thumbs: {
                    swiper: thumbsSwiper,
                },
                navigation: {
                    prevEl: arrowsContainer.querySelector('.slider__arrow--prev'),
                    nextEl: arrowsContainer.querySelector('.slider__arrow--next'),
                },
                lazy: {
                    loadPrevNext: true,
                },
            });
        }
    });
}

export default { init };
